(() => {
  if (customElements.get('pb-summer-clock')) return;
  function makeFormatter(timeZone) { return new Intl.DateTimeFormat('en-CA', {timeZone,year:'numeric',month:'2-digit',day:'2-digit'}); }
  function nextMidnight(now, formatter) {
    const today = formatter.format(new Date(now));
    let low = Math.floor(now / 1000), high = low + 30 * 3600;
    while (high - low > 1) {
      const mid = Math.floor((low + high) / 2);
      if (formatter.format(new Date(mid * 1000)) === today) low = mid;
      else high = mid;
    }
    return high * 1000;
  }
  class PBSummerClock extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      const formatter = makeFormatter(this.dataset.timezone || 'Europe/Brussels');
      let deadline = 0, previous = 0;
      this.update = () => {
        const now = Date.now();
        if (!deadline || now >= deadline || now < previous) deadline = nextMidnight(now,formatter);
        previous = now;
        const seconds = Math.max(0,Math.ceil((deadline - now)/1000));
        const values = [0,Math.floor(seconds / 3600),Math.floor(seconds % 3600 / 60),seconds % 60];
        ['days','hours','minutes','seconds'].forEach((key,index) => {
          const node = this.querySelector('[data-' + key + ']');
          const value = String(values[index]).padStart(2,'0');
          if (node && node.textContent !== value) node.textContent = value;
        });
      };
      this.update();
      this.timer = setInterval(this.update,1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  }
  customElements.define('pb-summer-clock',PBSummerClock);
})();
